module.exports = __webpack_public_path__ + "static/media/PM30.2353e638.png";